import React from 'react';

import { cn } from '@app/shared/utils/common';

export interface InfoRowProps {
  label: string;
  labelClassName?: string;
  value: React.ReactNode;
  withBottomBorder?: boolean;
  isEqual?: boolean;
}

export function InfoRow({
  label,
  labelClassName = '',
  value,
  withBottomBorder = true,
  isEqual = false,
}: InfoRowProps) {
  return (
    <div
      className={cn(
        'grid min-h-12 grid-cols-[100px_1fr] items-center gap-1.5 py-3',
        withBottomBorder && 'border-b border-[#f3f3f6]',
        isEqual && 'grid-cols-2'
      )}
    >
      <div
        className={cn('truncate text-sm font-medium text-gray-neutral', labelClassName)}
        title={label}
      >
        {label}
      </div>
      <div className="inline-flex w-full overflow-hidden wrap-break-word p-1 text-sm">{value}</div>
    </div>
  );
}
